export const successMessages = [
    'Thanks! 🎉 Your report is in, and you’ve officially made things better for everyone. We’ll take it from here.',
    'Got it! 🛠️ Thanks for flagging this — bugs hate being caught, and you just did us a favor.',
    '✅ Report received. Our troubleshooting gremlins are on it. Thanks for helping us squash this one!',
    'Nice catch! 👀 Thanks for submitting this — your future self (and teammates) appreciate it.',
    'All set. 🧩 Your submission is logged and queued for review. Thanks for helping keep things running smoothly.',
    'Boom — submitted. 💥 Thanks for calling this out. We’ll handle the rest.',
    'Thank you! 🙌 Issues only get fixed when people speak up — and you just did exactly that.'
]